import { baseMarkPattern } from './__base';
export var underline = function underline(text) {
  return baseMarkPattern(text, '+');
};